import { features as AT } from './AT';
import { features as CZ } from './CZ';
import { features as HR } from './HR';
import { features as HU } from './HU';
import { features as RO } from './RO';
import { features as SK } from './SK';
import { features as RS } from './RS';

export const featureMap = {
    AT,
    CZ,
    SK,
    RO,
    HU,
    HR,
    RS,
};
